module.exports = __webpack_public_path__ + "static/media/donor.6e4c7f4c.jpeg";